import mutations from './eprofileVedooltasok.mutations'
import actions from './eprofileVedooltasok.actions'
import getters from './eprofileVedooltasok.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
